<template
>
  <div class="survey">
    <div class="row">
      <div class="col-lg-12" v-if="!isLoading">
        <div class="widget">
          <div class="widget-body">
            <div class="row">
              <div class="col br-1">
                <h5 class="bb-1 pb-3 mb-3" style="font-size: 1rem;">{{ $t('labels.postal-address') }}</h5>

                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="addressee"
                    type="text"
                    :label="this.$t('labels.addressee')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="address_1"
                    type="text"
                    :label="this.$t('labels.address-one')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="address_2"
                    type="text"
                    :label="this.$t('labels.address-two')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="postal_code"
                    type="text"
                    :label="this.$t('labels.postal-code')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="postal_area"
                    type="text"
                    :label="this.$t('labels.postal-area')"
                ></text-field>
                <h5 class="bb-1 pb-3 mb-3 mt-5" style="font-size: 1rem;">{{ $t('labels.visiting-address') }}</h5>

                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="visitor_address_1"
                    type="text"
                    :label="this.$t('labels.address-one')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="visitor_address_2"
                    type="text"
                    :label="this.$t('labels.address-two')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="visitor_postal_code"
                    type="text"
                    :label="this.$t('labels.postal-code')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="visitor_postal_area"
                    type="text"
                    :label="this.$t('labels.postal-area')"
                ></text-field>
              </div>
              <div class="col br-1">
                <h5 class="bb-1 pb-3 mb-3" style="font-size: 1rem;">{{ $t('labels.number') }}</h5>

                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="phone_1"
                    type="tel"
                    :label="this.$t('labels.phone-one')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="phone_2"
                    type="tel"
                    :label="this.$t('labels.phone-two')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="mobile_1"
                    type="tel"
                    :label="this.$t('labels.mobile-one')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="mobile_2"
                    type="tel"
                    :label="this.$t('labels.mobile-two')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="fax"
                    type="text"
                    :label="this.$t('labels.fax')">
                </text-field>
                <h5 class="bb-1 pb-3 mb-3 mt-5" style="font-size: 1rem;">{{ $t('labels.organisation') }}</h5>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="organization_number"
                    type="text"
                    :label="this.$t('labels.org-number-shorten')"
                ></text-field-office>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="bankgiro"
                    type="text"
                    :label="this.$t('labels.bankgiro')"
                ></text-field-office>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="plusgiro"
                    type="text"
                    :label="this.$t('labels.plusgiro')"
                ></text-field-office>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="swish"
                    type="text"
                    :label="this.$t('labels.swish')"
                ></text-field-office>
              </div>
              <div class="col-5">
                <h5 class="bb-1 pb-3 mb-3" style="font-size: 1rem;">{{ $t('labels.online') }}</h5>

                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="email"
                    :infoBox="'Jourformuläret  - Kontaktuppgifter jour e-post'"
                    type="email"
                    :label="this.$t('labels.duty-email')"
                ></text-field-office>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="office_email"
                    :infoBox="'Jourformuläret  - Kontaktuppgifter kontor e-post'"
                    type="email"
                    :label="this.$t('labels.office-email')"
                ></text-field>

                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="website"
                    type="text"
                    :label="this.$t('labels.homepage')"
                ></text-field-office>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="facebook"
                    type="text"
                    :label="this.$t('labels.facebook')"
                ></text-field-office>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="twitter"
                    type="text"
                    :label="this.$t('labels.twitter')"
                ></text-field-office>
                <text-field-office
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice.office"
                    field="instagram"
                    type="text"
                    :label="this.$t('labels.instagram')"
                ></text-field-office>

                <h5 class="bb-1 pb-3 mb-3 mt-5" style="font-size: 1rem;">{{ $t('labels.the-newspaper') }}<info-box :field="'Jourformuläret  -Tidningen rubrikfält'" /></h5>

                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="newsletter_quantity"
                    type="text"
                    :label="this.$t('labels.number-of-ex')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="newsletter_subscription"
                    type="text"
                    :label="this.$t('labels.subscription')"
                ></text-field>
                <text-field
                    :editable="$store.getters.permissions.includes('office-section-contact-edit')"
                    @updateLocalOffice="updateLocalOffice"
                    :model="localOffice"
                    field="newsletter_notification"
                    type="text"
                    :label="this.$t('labels.notification-number')"
                ></text-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BojAPI from '@/api/boj';
import TextField from '@/components/ticket/localoffice/TextField';
import TextFieldOffice from '@/components/ticket/office/TextField';
import SelectField from '@/components/ticket/localoffice/SelectField';
import CheckboxField from '@/components/ticket/localoffice/CheckboxField';
import CheckboxFieldOffice from '@/components/ticket/office/CheckboxField';
import TextareaField from '@/components/ticket/localoffice/TextareaField';
import MemberList from '@/components/lists/member/MemberList';
import InfoBox from '@/components/InfoBox';

export default {
  name: 'survey-page',
  components: {
    TextField,
    TextFieldOffice,
    TextareaField,
    SelectField,
    CheckboxField,
    CheckboxFieldOffice,
    MemberList,
    InfoBox,
  },
  props: {
    id: Number,
  },

  computed: {
    localOfficeFieldOptions: function () {
      return this.$store.getters.localOfficeOptions;
    },

    sortedInformationFields() {
      const fields = this.localOffice.information_fields;

      return fields.sort(function (a, b) {
        return a.label < b.label;
      });
    },
    parentActions() {
      const actions = this.commentOptions;
      return actions.filter((item) => item.parent === null);
    },
    childActions() {
      if (this.comment.parentAction !== null) {
        let parentAction = this.comment.parentAction.id;
        const actions = this.commentOptions;
        return actions.filter((item) => item.parent === parentAction);
      } else {
        return [];
      }
    },

    childAction() {
      return this.ticketData.comments.filter((item) => item.id === this.comment.childAction.id);
    },
  },
  data() {
    return {
      informationFieldWait: false,
      comment: {
        comment: '',
        parentAction: null,
        childAction: null,
      },
      commentOptions: [],
      isLoading: true,
      localOffice: {
        label: '',
      },
      showDetailSection: 1,
    };
  },
  beforeRouteEnter(to, from, next) {
    BojAPI.getLocalOffice(to.params.id)
        .then((response) => {
          next((vm) => vm.setData(response.data));
        })
        .catch((error) => {
        });
  },
  beforeRouteUpdate(to, from, next) {
    this.localOffice = null;
    BojAPI.getLocalOffice(to.params.id).then((response) => {
      this.setData(response.data);
      next();
    });
  },
  mounted() {
    this.getActions();
  },
  methods: {
    /**
     * Update Information Field.
     *
     * @param localoffice
     * @param field
     * @param event
     */
    updateInformationField(localoffice, field, event) {
      this.informationFieldWait = true;
      if ((field.checked && field.foreign_id === null) || field.foreign_id !== null) {
        BojAPI.updateLocalOfficeInformationField(localoffice, field, event.target.value)
            .then((response) => {
              this.informationFieldWait = false;
              this.setData(response.data);
              this.$notify({
                group: 'foo',
                text: this.$t('labels.changes-saved'),
                type: 'success',
                duration: 3000,
              });
            })
            .catch((error) => {
              this.informationFieldWait = false;
              this.$notify({
                group: 'foo',
                text: this.$t('labels.no-permission'),
                type: 'warning',
                duration: 3000,
              });
            });
      }
    },

    /**
     * Save new comment
     */
    saveNewComment() {
      if (this.comment.parentAction == null || this.comment.childAction == null) {
        this.$notify({
          group: 'foo',
          text: this.$t('labels.missing-forum-event'),
          type: 'error',
          duration: 3000,
        });
      } else {
        BojAPI.saveLocalOfficeComment(this.localOffice.id, this.comment)
            .then(() => {
              BojAPI.getLocalOffice(this.localOffice.id).then((response) => {
                this.setData(response.data);
              });
              this.$notify({
                group: 'foo',
                text: this.$t('labels.note-saved'),
                type: 'success',
                duration: 3000,
              });

              this.comment = {
                comment: '',
                parentAction: null,
                childAction: null,
              };
            })
            .catch((error) => {
              this.$notify({
                group: 'foo',
                text: this.$t('labels.no-permission-adding-note-local-office'),
                type: 'warning',
                duration: 3000,
              });
            });
      }
    },

    /**
     * Get available actions
     */
    getActions() {
      BojAPI.getLocalOfficeActions().then((response) => {
        this.commentOptions = response.data.data;
      });
    },

    /**
     * Update Local Office
     * @param ticket
     */
    updateLocalOffice(ticket) {
      this.$emit('updateLocalOffice', ticket);
    },
    setShowDetailSection(section) {
      this.showDetailSection = section;
    },

    setData(payload) {
      this.localOffice = payload.data;
      this.isLoading = false;
    },
  },
};
</script>
